import { DefaultDialogExample } from "../../../../../../packages/design-system/src/Dialog/readmeHelper.tsx";
import * as React from 'react';
export default {
  DefaultDialogExample,
  React
};